import { makeStyles } from '@material-ui/core'
export const useStyles = makeStyles(() => ({
    addCompanyContainer: {
        marginLeft: 'auto'
    },
    boxItemEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        color: 'var(--primary-main)'
    }
}))
